<template>
  <v-list-item-group
    mandatory>
    <v-list dense>
      <v-list-item to="/" exact>
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>ホーム</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-if="this.$route.params.id">
        <v-subheader 
          class="mt-3 grey--text text--darken-1">
         現在の部屋
        </v-subheader>

          <v-row 
            id="fix_bar"
            class="px-4 chat_name"
            align="center"
            no-gutters>
            <v-col cols="10">
              <v-list-item-title v-show="!input_room">{{chat_name}}</v-list-item-title>
              <v-text-field
                dense
                v-show="input_room"
                v-model="room_input"
                @keypress.enter.exact.prevent= "changeRoom()"
                label="部屋名"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn outlined x-small color="#133a65"
                v-if="isOwner"
                type="button"
                @click="changeRoom()"
              >
                変更
              </v-btn>
            </v-col>
          </v-row>

      </template>

      <v-subheader class="mt-3 grey--text text--darken-1">
       入室履歴
      </v-subheader>
      <section
        v-for="{ key, link, name } in rooms_in"
        :key="key">  
        <v-list-item :to="{ name: 'Home', params: { id: link } }" exact>
          <v-row 
            align="center"
            no-gutters>
            <v-col cols="10">
              <v-list-item-title>{{name}}</v-list-item-title>
            </v-col>
            <v-col id="fix_bar" cols="2">   
              <v-btn 
                @click.prevent="doExitRoom(link)"
                color="pink darken-3"
                outlined x-small>
                削除
              </v-btn>
            </v-col>
          </v-row>          
        </v-list-item>
      </section>
    </v-list>
  </v-list-item-group>
</template>

<script>
import firebase from 'firebase'
import Firebase from './../firebase'
import { mapState } from 'vuex'

export default {
  data(){
    return {
      room_input: '',
      input_room: false,
    }
  },
  created () {
    const user = this.$store.getters.user
    this.roomDb = firebase.database().ref('room')
    if (user) {
      this.roomDb.on('child_changed', this.roomChanged)
    } else {
      this.roomDb.off('child_changed', this.roomChanged)
    }
  },
  computed: {
  	...mapState([
      'rooms_in'
  	]),
    isOwner() {
      const index = this.$store.getters.getRooms.findIndex((v) => v.key === this.$route.params.id)
      if(index != -1 && this.$store.getters.getRooms[index].owner == this.$store.getters.user.uid) return true
      return false     
    },
    chat_name() {
      const index = this.$store.getters.getRooms.findIndex((v) => v.key === this.$route.params.id)
      if(index != -1) return this.$store.getters.getRooms[index].name
      return '部屋名不明'
    },
  },
  methods: {
    doExitRoom(key){
      this.$store.dispatch('doExitRoom', key)
    },
    changeRoom (){
      if(this.input_room && this.room_input != ''){
        const index = this.$store.getters.getRooms.findIndex((v) => v.key === this.$route.params.id)
        const owner = this.$store.getters.getRooms[index].owner
        if (this.$store.getters.user.uid === owner) {
          firebase.database().ref('room/'+this.$route.params.id).update({
            name: this.room_input,
          })
        }
        else alert('ルーム名はルーム作成者のみが変更できます。')
      }
      this.room_input = ''
      this.input_room = !this.input_room
    },
    roomChanged (snap) {
      const index = this.$store.getters.getRooms.findIndex((v) => v.key === snap.key)
      const index_in = this.$store.getters.getRoomsIn.findIndex((v) => v.link === snap.key)
      const changed_room = {
        name: snap.val().name,
        index: index,
        index_in: index_in,
      }
      this.$store.dispatch('changeRoom', changed_room)
    },
  }
}
</script>

<style scoped>
.v-application a  {
  text-decoration: none;
}
.v-list-item__title{
  max-width: 170px;
}
.chat_name{
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1rem;
}
</style>